// Copyright (c) 2021 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import OptionsDropDown from '../../shared/components/options-drop-down';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getShippingInventoryLocations } from './repositories';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { withRouter } from 'react-router-dom';

class AtpCalendar extends Component {

    state = {
        shippingLocations: [],
        selectedShippingLocation: null
    };

    componentDidMount = () => {

        this.props.increaseCounter();
        getShippingInventoryLocations( ).then( response => {

            this.setState( {
                shippingLocations: response
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    handleShippingLocationChange ( val ) {

        this.setState( {
            selectedShippingLocation: val
        } );

    }

    render () {

        const {
            shippingLocations, selectedShippingLocation
        } = this.state;
        const { pathname } = this.props.history.location;

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <header>
                    <h2 className="page-header">ATP Calendar</h2>
                </header>

                <main>
                    <section className="section-container">
                        <div className="atp-calendar-options">
                            <button className="primary-button" type="button" onClick={() => this.props.history.push( `${pathname}/calendar?type=factory` )}>
                                <span> Factory </span>
                            </button>
                            <p>
                                The Factory calendar shutdown days will be applied to all families.
                            </p>
                            <div className="atp-calendar-shipping-options">
                                <OptionsDropDown
                                    className="atp-calendar-select"
                                    isPlaceholderTranslated={true}
                                    onChange={this.handleShippingLocationChange.bind( this )}
                                    optionDisplayAttributes={['value']}
                                    optionKey="id"
                                    options={shippingLocations}
                                    placeholder="Select Inventory Location"
                                    selectedValue={selectedShippingLocation}
                                />
                                <button className="primary-button" type="button" onClick={() => this.props.history.push( `${pathname}/calendar?type=shipping&location=${selectedShippingLocation}` )} disabled={selectedShippingLocation === null}>
                                    <span> Shipping </span>
                                </button>
                            </div>
                            <p>
                                The Shipping calendar is independent of factory calendar.
                                Shipping shutdown days are for all Families for the factory.
                                There can be factory shutdown but shipping can sitll be active.
                            </p>

                        </div>
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

AtpCalendar.displayName = 'AtpCalendar';
AtpCalendar.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object,
    location: PropTypes.object,
    history: PropTypes.object
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( AtpCalendar ) );
